/* LIVS - bundles card in the homepage "Stock up and save" row.

   Built from three separate <img> tags like the other tier cards, so it inherits the theme's
   own .tier-pics img sizing and matches them at every breakpoint. The bottles are a REAL
   bundle (Gut Health: Fiber + Probiotic + Digestive Enzymes) so the card reads as a curated
   set, in contrast to the tier cards which show the same bottle repeated.

   LAYOUT BUDGET - measured live at 1440px, do not exceed it when editing the copy:
     card 351px - 44px padding = 307px content
     .tier-pics holds three 92px bottles and settles at 208px (they overlap)
     => the text column is only 80px wide
   At 80px: "Let us pick" = 1 line, "Skip the picking" = 2, "We picked for you" = 3.
   Measured pill widths in the pill's own typography (text + 24px padding):
     "Bundles" 77  |  "Bundles ->" 93  |  "12 bundles" 94  |  "Our bundles" 105
     "Recommended" 125  |  "Recommended bundles" 182
   Only "Bundles" fits the 80px column. "Recommended bundles" needs 182px - more than twice
   the room - and even the single word "Recommended" (125px) overflows, so wrapping does not
   rescue it. Do not re-attempt longer CTA copy without first widening the rail.

   Copy note: bundles are NOT a bigger discount than Buy-any-3 (both are the same automatic
   -$20 order discount), so the card promises curation, not savings.

   ============================================================================
   RAIL ALIGNMENT - why there is no JS measurement here any more
   ============================================================================
   .tier-pics is sized by its contents, so the 2-bottle "Buy any 2" card measured 150px on
   desktop / 98px on mobile while the 3-bottle cards measured 208 / 130. That pushed the first
   card's title ~32px left of the other two - the three titles did not line up.

   Two measure-and-pin attempts both failed, and both failures are worth remembering:
     1. Measuring inside requestAnimationFrame - rAF never fires while the tab is hidden, so
        the widths were cleared and never re-pinned. A page opened in a background tab lost
        its alignment completely.
     2. Measuring synchronously - the pin held, but the value did not track the breakpoint:
        the rail stayed at the desktop 208px on mobile, shrinking the mobile text column from
        176px to 98px and wrapping "Buy any 2 bottles" onto a second line.

   So: no measuring. The 2-bottle card simply gets a third bottle that is present for layout
   but not painted (visibility:hidden reserves its box). Every rail then holds three images and
   they match naturally at EVERY breakpoint, using the theme's own sizing and overlap rules -
   no widths, no resize handler, nothing to go stale. aria-hidden keeps it out of the a11y tree. */
(function () {
  var PATH_OK = /^\/(index)?$/.test(location.pathname.replace(/\/+$/, '') || '/');
  if (!PATH_OK) return;

  var BASE = 'https://cdn.shopify.com/s/files/1/0565/3240/2356/files/';
  var SHOTS = [
    BASE + 'Fiber_Main_400x.png?v=1762244259',
    BASE + 'LV3224_Probiotics_44ct-2_400x.png?v=1762257529',
    BASE + '2_8fc00e10-20dd-4db5-aa81-0db9b14e2a30_400x.png?v=1784228351'
  ];
  var HREF = '/pages/bundles';
  var TITLE = 'Let us pick';
  var PILL = 'Bundles';

  function css() {
    if (document.getElementById('livs-bundle-tout-css')) return;
    var s = document.createElement('style');
    s.id = 'livs-bundle-tout-css';
    s.textContent =
      '.tier-bundle{text-decoration:none;color:inherit;' +
      'transition:transform .2s ease,border-color .2s ease,box-shadow .2s ease}' +
      '.tier-bundle:hover{transform:translateY(-3px);border-color:#F0C9DA;' +
      'box-shadow:0 16px 30px -22px rgba(56,68,92,.55)}' +
      '.tier-bundle .tier-s{white-space:nowrap}' +
      '.livs-ghost-bottle{visibility:hidden!important;pointer-events:none!important}' +
      '@media(prefers-reduced-motion:reduce){.tier-bundle{transition:none}}';
    document.head.appendChild(s);
  }

  /* Pad every rail up to the largest bottle count with unpainted clones, so all the rails
     are the same width by construction rather than by measurement. */
  function padRails() {
    var rails = [].slice.call(document.querySelectorAll('.tiers .tier-pics'));
    if (rails.length < 2) return;
    var counts = rails.map(function (r) { return r.querySelectorAll('img').length; });
    var max = Math.max.apply(null, counts);
    if (!max) return;
    rails.forEach(function (r) {
      var have = r.querySelectorAll('img:not(.livs-ghost-bottle)').length;
      var ghosts = r.querySelectorAll('img.livs-ghost-bottle').length;
      var need = max - have - ghosts;
      if (need <= 0) return;
      var model = r.querySelector('img');
      if (!model) return;
      for (var n = 0; n < need; n++) {
        var g = model.cloneNode(false);
        g.classList.add('livs-ghost-bottle');
        g.setAttribute('aria-hidden', 'true');
        g.alt = '';
        r.appendChild(g);
      }
    });
  }

  function build() {
    var wrap = document.querySelector('.tiers');
    if (!wrap) return false;
    if (wrap.querySelector('.tier-bundle')) { padRails(); return true; }
    if (!wrap.querySelector('.tier')) return false;
    css();

    var a = document.createElement('a');
    a.className = 'tier tier-bundle';
    a.href = HREF;

    var pics = document.createElement('span');
    pics.className = 'tier-pics';
    SHOTS.forEach(function (src) {
      var i = document.createElement('img');
      i.src = src; i.alt = ''; i.loading = 'lazy'; i.decoding = 'async';
      pics.appendChild(i);
    });

    var t = document.createElement('span');
    t.className = 'tier-t';
    var l = document.createElement('span'); l.className = 'tier-l'; l.textContent = TITLE;
    var p = document.createElement('span'); p.className = 'tier-s'; p.textContent = PILL;
    t.appendChild(l); t.appendChild(p);

    a.appendChild(pics); a.appendChild(t);
    wrap.appendChild(a);
    padRails();
    return true;
  }

  if (build()) return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build, { once: true });
  }
  var tries = 0;
  var iv = setInterval(function () { if (build() || ++tries > 40) clearInterval(iv); }, 250);
})();
